
import { Metadata } from '@scoir/tracking'

import { FIELDS } from 'common/metadata-constants'
import { DOMAIN_TYPES } from 'common/track-event-constants'
import AwesomeBar from 'components/AwesomeBar'

import { useFocusDropdownSections } from './use-focus-dropdown-sections'
import { useSearchConfigurations } from './use-search-configurations'
import { ISearchConfigurationsResult } from './use-search-configurations/types'

const StudentAwesomeBar = () => {
  const { searchConfigurations, allResultsOrder }: ISearchConfigurationsResult = useSearchConfigurations()
  const focusDropdownSections = useFocusDropdownSections()
  return (
    <Metadata
      value={{
        [FIELDS.DOMAIN_TYPE]: DOMAIN_TYPES.GLOBAL_SEARCH,
      }}
    >
      <AwesomeBar
        searchConfigurations={searchConfigurations}
        allResultsOrder={allResultsOrder}
        focusDropdownSections={focusDropdownSections}
      />
    </Metadata>
  )
}

export default StudentAwesomeBar
